import { contractTermsOptions } from "@/common/const/types/index.const";
import { FormFieldsStrategyType } from "@/common/types";

const ipAddressManualFormStrategy: FormFieldsStrategyType[] = [
  {
    inputType: "text",
    label: "IP Range",
    name: "ipRange",
    required: true,
  },
  {
    inputType: "select",
    label: "Contract Term",
    name: "contractTerm",
    required: true,
    options: [...contractTermsOptions],
  },
];
export default ipAddressManualFormStrategy;
